import moment, { Moment } from "moment-timezone";

export interface ScheduledMessage {
  startDateTime?: string | null;
  endDateTime?: string | null;
}

function parseScheduledDateTime(dateTime?: string | null): Moment | null {
  if (!dateTime) return null;

  const parsedDateTime = moment.parseZone(dateTime, moment.ISO_8601, true);

  return parsedDateTime.isValid() ? parsedDateTime : null;
}

export function isScheduledMessageActive(message: ScheduledMessage, now: Moment = moment()): boolean {
  const startDateTime = parseScheduledDateTime(message.startDateTime);
  const endDateTime = parseScheduledDateTime(message.endDateTime);

  if (startDateTime && now.isBefore(startDateTime)) return false;
  if (endDateTime && now.isAfter(endDateTime)) return false;

  return true;
}
